/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div v-if="(showBtn||vuex['showCtl']!==false)&&roleAclDisplayFlag" style="display: contents;">
    <a-dropdown
      :trigger="['click']"
      :style="{...(props.remarkWidth ? {'--remarkWidth': props.remarkWidth + 'px'} : {}), ...(props.backgroundColor ? {'--bgColor': props.backgroundColor} : {})}"
      @visibleChange="onExportDropdownOpenChange"
    >
      <xm-button :data-label="props.label"
                 :props="props"
                 :btnLabel="roleAclLabel"
                 :showLabel="false"
                 :style="{'cursor': 'pointer', ...elCtlStyle}"
                 :styles="styles"
                 :dataConfig="dataConfig"
                 :borderConfig="borderConfig"
                 :model="model"
                 :events="events"
                 :disabledBtnAcl="disabledBtnAcl"
                 :disabled="exporting||roleAclDisabledFlag"
                 :loadingFlag="exporting"
                 :id="props.key"
      >
      </xm-button>
      <template #overlay>
        <a-menu trigger-sub-menu-action="hover" @click="clickMenu" style="max-width: 240px">
          <!-- 导出选中：有方案时悬停展示方案子菜单，点击标题本身不带 templateId -->
          <a-sub-menu
            v-if="props.selOutImport && hasExportSchemes"
            key="outSelRecordSub"
            :disabled="selExportDisabled"
          >
            <template #title>
              <span
                class="export-menu-direct"
                :class="{ 'is-disabled': selExportDisabled }"
                @click.stop="onDirectExportClick('outSelRecord')"
              >
                导出选中<template v-if="!props.hideCount">（选中{{ selCount }}条）</template>
              </span>
            </template>
            <a-menu-item
              v-for="s in exportSchemeOptions"
              :key="`outSelRecord:${s.id}`"
              :disabled="selExportDisabled"
            >
              <span class="export-scheme-menu-name" :title="s.name">{{ s.name }}</span>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item
            v-else-if="props.selOutImport"
            key="outSelRecord"
            :disabled="selExportDisabled"
          >
            <span>导出选中<template v-if="!props.hideCount">（选中{{ selCount }}条）</template></span>
          </a-menu-item>

          <!-- 导出所有：有方案时悬停展示方案子菜单，点击标题本身不带 templateId -->
          <a-sub-menu
            v-if="props.allOutImport && hasExportSchemes"
            key="outAllSub"
            :disabled="exporting"
          >
            <template #title>
              <span class="export-menu-direct" @click.stop="onDirectExportClick('outAll')">
                导出所有<template v-if="!props.hideCount">（共{{ totalCount }}条）</template>
              </span>
            </template>
            <a-menu-item
              v-for="s in exportSchemeOptions"
              :key="`outAll:${s.id}`"
              :disabled="exporting"
            >
              <span class="export-scheme-menu-name" :title="s.name">{{ s.name }}</span>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item v-else-if="props.allOutImport" key="outAll" :disabled="exporting">
            <span>导出所有<template v-if="!props.hideCount">（共{{ totalCount }}条）</template></span>
          </a-menu-item>

          <a-menu-item v-if="props.exportFieldConfigFlag" key="configExportScheme">
            <span>配置导出方案</span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <ExportSchemeModal
      v-model:visible="exportSchemeModalVisible"
      :export-column-params="exportColumnParams"
      @menu-schemes-change="onExportSchemeMenuChange"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmOutImportBtnCtl",
});
</script>

<script lang="ts" setup>
import {Dropdown as ADropdown,Button as AButton,Menu as AMenu,MenuItem as AMenuItem, SubMenu as ASubMenu, message} from 'ant-design-vue'
import XmButton from "@/main-page-base/ctls/baseCtls/xmButton/index.vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {useComElState} from "@/main-page/ctls/hooks/useComElState";
import {initPropDefValues} from "@/utils";
import {useGridTableStore} from "@/store/modules/gridTableStore";
import {exportAll, exportByIds} from "@/main-page/servers/formPageServer";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {usePageRoleAcl} from "@/main-page/ctls/hooks/usePageRoleAcl";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import GoingUtils from "@/utils/goingUtils";
import ExportSchemeModal from "./coms/ExportSchemeModal.vue";
import {getPageExportConfigByPageCode} from "./server/pageExportConfig";

const ASYNC_EXPORT_TIP = '导出任务已提交，请稍后到操作记录中下载';

const gridTableStore: any = useGridTableStore();
const pageModelsStore = usePageModelsStore();

interface propTypes {
  dataConfig: any,
  elConfig: any,
  props: any,
  events: any,
  pItem:string,
  styles: any,
  model: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  elConfig: {},
  dataConfig: {},
  pItem:'',
  styles: {},
  events: [],
  props: {},
  model: {},
})
const {curElIndex, dataConfig,pItem, props, styles, model, events, elConfig}: any = toRefs(propsPage);

initPropDefValues({
  dataConfig: {
    userDef: true,
    "dataFormType": "dynamic",
  },
}, elConfig);

initPropDefValues({
  pItem:propsPage.pItem,
  selOutImport: true,
  hasDefValue:false,
  allOutImport: true,
  showCtl: true,
  hideCount: false,
  asyncOutImport: false,
  exportFieldConfigFlag: false,
  selOutWithListQuery: false,
}, props);

const exporting = ref(false);
const exportSchemeModalVisible = ref(false);

/** 导出下拉菜单用的方案列表（按 pageCode 缓存，增删改后刷新） */
interface ExportSchemeOption {
  id: string;
  name: string;
}
const exportSchemeOptions = ref<ExportSchemeOption[]>([]);
/** 当前缓存对应的 pageCode；与 exportSchemePageCode 一致时表示缓存有效 */
const exportSchemeCachePageCode = ref<string | null>(null);
const hasExportSchemes = computed(() => exportSchemeOptions.value.length > 0);

/** getByPageCode 使用的 pageCode，与导出方案配置保持一致 */
const exportSchemePageCode = computed(() => {
  const curProps = unref(props);
  return curProps.mainAndSubExtend === true
    ? curProps.mainPageColConfigCode
    : GoingUtils.getPageCode();
});

const parseExportSchemeOptions = (res: any): ExportSchemeOption[] =>
  Array.isArray(res)
    ? res
      .filter((item) => item?.id != null && item?.id !== '')
      .map((item) => ({
        id: String(item.id),
        name: item.configName ?? item.name ?? '',
      }))
      .filter((item) => !!item.name)
    : [];

const setExportSchemeCache = (pageCode: string, options: ExportSchemeOption[]) => {
  exportSchemeOptions.value = options;
  exportSchemeCachePageCode.value = pageCode;
};

const invalidateExportSchemeCache = () => {
  exportSchemeCachePageCode.value = null;
  exportSchemeOptions.value = [];
};

/** 配置弹窗增删改成功后，直接更新下拉菜单缓存，避免重复请求 */
const onExportSchemeMenuChange = (options: ExportSchemeOption[]) => {
  const pageCode = exportSchemePageCode.value;
  if (pageCode) {
    setExportSchemeCache(pageCode, options);
  }
};

/** 展开导出下拉时加载方案列表；同一 pageCode 下复用缓存 */
const loadExportSchemesForMenu = (force = false) => {
  if (!unref(props).exportFieldConfigFlag) {
    invalidateExportSchemeCache();
    return;
  }
  const pageCode = exportSchemePageCode.value;
  if (!pageCode) {
    invalidateExportSchemeCache();
    return;
  }
  if (!force && exportSchemeCachePageCode.value === pageCode) {
    return;
  }
  getPageExportConfigByPageCode({
    pageCode,
    backFun: (res: any) => {
      setExportSchemeCache(pageCode, parseExportSchemeOptions(res));
    },
    errorFun: () => {
      invalidateExportSchemeCache();
    },
  });
};

watch(exportSchemePageCode, (pageCode) => {
  if (exportSchemeCachePageCode.value !== pageCode) {
    invalidateExportSchemeCache();
  }
});

watch(() => unref(props).exportFieldConfigFlag, (enabled) => {
  if (!enabled) {
    invalidateExportSchemeCache();
  }
});

/** 展开导出下拉时加载方案列表；同一 pageCode 下复用缓存。
 * 注意：ant-design-vue 3 的 Dropdown 事件名为 visibleChange（非 openChange），
 * 否则展开时预查不会触发，只有打开配置弹窗写缓存后子菜单才出现。
 */
const onExportDropdownOpenChange = (open: boolean) => {
  if (open) {
    loadExportSchemesForMenu();
  }
};

/** 直接点击「导出所有/导出选中」标题（不带 templateId）；子菜单 title 的自定义点击需自行校验禁用态 */
const onDirectExportClick = (exportKey: string) => {
  if (exporting.value) return;
  if (exportKey === 'outSelRecord' && selCount.value === 0) return;
  clickMenu({key: exportKey});
};

const selCount = computed(() => {
  if (unref(props).gridKey && gridTableStore.getGridSels(unref(props).gridKey)) {
    return gridTableStore.getGridSels(unref(props).gridKey).length;
  } else {
    return 0;
  }
})
/** 导出选中不可用：无选中行或正在导出中 */
const selExportDisabled = computed(() => exporting.value || selCount.value === 0);
const totalCount = computed(() => {
  if (unref(props).gridKey) {
    return gridTableStore.getGridTotal(unref(props).gridKey) || 0;
  } else {
    return 0;
  }
})

const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});
//当前用户的角色配置权限信息 供按钮控制显示隐藏与禁用（未命中配置默认显示且可编辑；newFieldName 与当前名称不一致时替换按钮文案）
const {roleAclDisplayFlag,roleAclDisabledFlag,roleAclLabel}=usePageRoleAcl({props});
const {elCtlStyle, elBaseStyle, formElComClass, formElComSty} = useCtlStyle({
  styles,
  props,
  propsStyl: ['width'],
  outExtendProp: unref(pItem)==='xmForm'?['marginLeft','marginTop', 'marginRight', 'marginBottom', 'paddingLeft']:[]
});
const {clickEvent, viewModel} = useComEvent({events});
const emits = defineEmits(['clickBtn']);
const {modelObj} = useComElState({initModel: false, elConfig, props});
const clickBtn = () => {
  emits('clickBtn', {});
  clickEvent('click', {record: unref(modelObj)});
}

/**
 * 打开"配置导出方案"弹窗前的前置校验（与 exportColumnParams 所需配置一致）
 * 1. 主子界面开：关联界面 code、主表组件 key 必填
 * 2. 部件界面开：部件界面/模块编码必填（与主子界面开关无关）
 */
const validateExportSchemeConfig = function () {
  const curProps = unref(props);
  if (curProps.mainAndSubExtend === true) {
    if (!curProps.mainPageColConfigCode) {
      message.warning('请先配置关联界面code');
      return false;
    }
    if (!curProps.mainGridKey) {
      message.warning('请先配置主表组件key');
      return false;
    }
  }
  if (curProps.subComPageFlag === true) {
    if (!curProps.subComPageCode) {
      message.warning('请先配置部件界面编码');
      return false;
    }
    if (!curProps.subComModuleCode) {
      message.warning('请先配置部件模块编码');
      return false;
    }
  }
  return true;
}

/**
 * "获取可导出组件列"接口的请求参数
 * pageCode：主子界面开启时用关联界面code，否则用当前界面 pageCode
 * mainKey：优先用「主表组件key」，未填时回退导出按钮绑定的 gridKey
 */
const exportColumnParams = computed(() => {
  const curProps = unref(props);
  const params: any = {
    pageCode: curProps.mainAndSubExtend === true
      ? curProps.mainPageColConfigCode
      : GoingUtils.getPageCode(),
    mainKey: curProps.mainGridKey || curProps.gridKey,
  };
  if (curProps.subGridKey) {
    params.subKey = curProps.subGridKey;
  }
  if (curProps.subComPageFlag === true) {
    params.bjModuleCode = curProps.subComModuleCode;
    params.bjPageCode = curProps.subComPageCode;
  }
  return params;
});

/**
 * 点击导出菜单选项
 * key 格式：outAll | outSelRecord | outAll:{schemeId} | outSelRecord:{schemeId} | configExportScheme
 */
const clickMenu = async function ({key}) {
  if (key === 'configExportScheme') {
    if (!validateExportSchemeConfig()) {
      return;
    }
    exportSchemeModalVisible.value = true;
    return;
  }
  let exportKey = key;
  let templateId: string | undefined;
  if (typeof key === 'string' && key.includes(':')) {
    const parts = key.split(':');
    exportKey = parts[0];
    templateId = parts[1];
  }
  if (exporting.value) return;
  if (exportKey === 'outSelRecord' && selCount.value === 0) return;
  const gridObj = gridTableStore.getGridObjByKey(unref(props).gridKey);
  if (gridObj) {
    const extraParams: any = unref(props).mainOutImport ? {fillMainData: true} : {};
    if (templateId) {
      extraParams.templateId = templateId;
    }
    exporting.value = true;
    try {
      if (exportKey === 'outAll') {
        const result = await exportAll({gridObj, dataConfig, gridKey: unref(props).gridKey, gridTableStore, props, pageModelsStore, extraParams})
        if (result === 'async') {
          message.success(ASYNC_EXPORT_TIP);
        }
      } else if (exportKey === 'outSelRecord') {
        const result = await exportByIds({gridObj, dataConfig, gridKey: unref(props).gridKey, gridTableStore, props, pageModelsStore, extraParams})
        if (result === 'async') {
          message.success(ASYNC_EXPORT_TIP);
        }
      }
    } finally {
      exporting.value = false;
    }
  }
}

</script>

<style type="text/css" lang="less">
.export-menu-direct {
  display: inline-block;
  width: 100%;
  cursor: pointer;

  &.is-disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
}

/** 导出方案子菜单名称：限制最大宽度，超出省略；悬停 title 看全文 */
.export-scheme-menu-name {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
